module.exports = "\r\n  <div class=\"modal-contents\" id=\"loader\">\r\n      <app-loader></app-loader>\r\n  </div>   \r\n     \r\n"